
var BrowserFS = require('browserfs');
var fs = BrowserFS.BFSRequire('fs');
module.exports.internalModuleReadFile = function(...args) {
  return fs.readFileSync(...args);
};
module.exports.internalModuleStat = function(file) {
  try {
    var stats = fs.statSync(file);
    return stats.isFile() ? 0 : 1;
  } catch (error) {
    return -1;
  }
};



// WEBPACK FOOTER //
// ./src/binding_fs.js